/**
 * Helper utility to check if any filter parameters have been selected
 * Used to determine whether the Filter button should be enabled or disabled or perform any other action
 */

/**
 * @param {Object} filterObject - The filter state object containing all filter fields
 * @param {Array<string>} excludeFields - Optional array of field names to exclude from the check (e.g., fields that shouldn't affect button state)
 * @returns {boolean} - Returns true if at least one filter field has a value, false otherwise
 *
 */
export function hasFilterValues(filterObject, excludeFields = []) {
  if (!filterObject || typeof filterObject !== "object") {
    return false;
  }

  for (const key in filterObject) {
    // Skip excluded fields
    if (excludeFields.includes(key)) {
      continue;
    }

    const value = filterObject[key];

    // Check for non-empty values
    if (value !== null && value !== undefined && value !== "") {
      // For boolean values (including false), consider them as selected
      if (typeof value === "boolean") {
        return true;
      }

      // For objects (like dropdown selections), check if they have content
      if (typeof value === "object" && Object.keys(value).length > 0) {
        return true;
      }

      // For strings and numbers, check if they're not empty
      if (
        (typeof value === "string" && value.trim() !== "") ||
        typeof value === "number"
      ) {
        return true;
      }
    }
  }

  return false;
}